import store from "@/store"
import { isAfter, parseISO } from "date-fns/esm"

const matchedPathBlacklist = [
  "/account",
  "/account/profile",
  "/account/subscriptions",
  "/hairquiz",
  "/login",
  "/register"
]

export default (to, from, next) => {
  if (
    matchedPathBlacklist.includes(to.matched[0].path) ||
    (from.path === "/" && from.name === null)
  ) {
    // the path is either a blacklisted path, or its the first page the user arrives on (currently set like this so as not to interfere with store locale switcher modal)

    store.commit("account/SET_VALID_NEWSLETTER_ROUTE", false)
    next()
  } else {
    store.commit("account/SET_VALID_NEWSLETTER_ROUTE", true)
    if (store.state.account.marketingPrefs.subscribedToMarketing === true) {
      // the user is already subscribed
      next()
    } else {
      // the user is not already subscribed (either an unregistered user or registered but not agreed to marketing), or the user has cleared cookies.

      if (store.state.account.marketingPrefs["declinedMarketing"] === true) {
        if (
          isAfter(
            Date.now(),
            parseISO(
              store.state.account.marketingPrefs["declinedMarketing_resetDate"]
            )
          )
        ) {
          // OR the user has previously declined to subscribe via the modal, but that rejection has now expired (validity 24 hours?)
          store.commit("account/SET_MARKETING_DECLINED", false)
        }
      }
      next()
    }
  }
}
